import React from 'react'
import ModalComponent from './ModalComponent'

export default function ChnageStatus(props) {
    return (
        <div>
            {props.showModal ?
                <ModalComponent>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" checked />
                        <label class="form-check-label" for="flexRadioDefault1">
                            Live
                        </label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" />
                        <label class="form-check-label" for="flexRadioDefault2">
                            Close
                        </label>
                    </div>
                </ModalComponent> : ""}
        </div>
    )
}
